const neutralTheme = {
    orgColors: {
        primary: "#4F98CA",
        secondary: "#272727",
        tertiary: "#EFFFFB",
        dark: "#8E8B82  ",
        medium: "#babfc3",
        light: "#F7F7F7",
    },
    typography: {
        allVariants: {
            color: "#272727",
        },
        body1: {
            color: "#272727",
        },
        body2: {
            color: "#272727",
        },
    },
    palette: {
        type: "neutral",
        org: "Checkventory",
        primary: {
            main: "#4F98CA",
            secondary: "#272727",
            tertiary: "#EEEEEE",
        },
        loginScreen: {
            loginContainer: {
                background: "#FFFFFF",
            },
            formContainer: {
                background: "#F7F7F7",
            },
        },
        menuContainer: {
            background: "#fff",
            color: "#4F98CA",
        },
        assetListHeading: {
            default: "#fafafa",
            net: "#8E8B82",
        },
        background: {
            darkBackground: "#4F98CA",
            mediumBackground: "#babfc3",
            lightBackground: "#F2F0EE",
        },
        border: {
            primary: "#4F98CA",
            darkBorder: "#272727",
            mediumBorder: "#babfc3",
            lightBorder: "#F2F0EE",
        },
        tabButtons: {
            active: "#4F98CA",
            activeText: "#F7F7F7",
            default: "#F2F0EE",
            defaultText: "#4F98CA",
        },
        text: {
            primary: "#4F98CA",
            secondary: "#272727",
            darkText: "#8E8B82",
            contrastText: "#4F98CA",
        },
        iconsColor: {
            primary: "#4F98CA",
            secondary: "#272727",
        },
        success: {
            main: "#66bb6a",
        },
        info: {
            main: "#29b6f6",
        },
        warning: {
            main: "#ffa726",
        },
        error: {
            main: "#f44336",
        },
    },
    props: {
        MuiTooltip: {
            arrow: true,
        },
    },
    components: {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: "#272727",
                },
            },
        },
    },
};

export default neutralTheme;
